import { JsonSchema } from "@jsonforms/core";

export const justReturnControl = (
  readonly: boolean | undefined,
  hidden: boolean | undefined,
  isCheckResults: boolean | undefined,
  isNullable: boolean
) => readonly || hidden || !isCheckResults || !isNullable;

export const schemaIsNullable = (schema: JsonSchema) => {
  if (Array.isArray(schema.type)) {
    return schema.type.includes("null");
  }
  if (typeof schema.type === "string") {
    return schema.type === "null";
  }
  return false;
};
